export function isValidCvr(cvr: string) {
    return /^(?:\d{8})?$/.test(cvr);
}

export const IsValidDanishCVR = cvr => {
    if (!cvr) return true;

    // CVR numbers starting with 00 are for Faroe Islands and should be ignored
    if (cvr.startsWith('00')) {
        return true;
    }

    const control = [2, 7, 6, 5, 4, 3, 2, 1];
    const components = (cvr + '')
        .replace(/\D/g, cvr + '')
        .split('')
        .map(c => Number.parseInt(c));

    if (components.length !== 8) return false;

    const sum = components.map((c: any, i: any) => c * control[i]).reduce((a, c) => a + c, 0);
    return sum % 11 === 0;
};

// Extract exactly 8 consecutive digits possibly preceded by non-digits
export function formatCvr(cvr: string) {
    return /^\D*(\d{8})$/g.exec(cvr)?.[1];
}
